/* footer.js - the footer's one behaviour, and it moves nothing.

   The menu columns are <details> elements that ship CLOSED, which is the
   phone's accordion. From 1024px the block's CSS pins their content visible
   through ::details-content whatever the `open` attribute says, so on a modern
   engine the links are on screen from the first frame with no script at all.
   This module only makes the attribute agree with what is painted: above
   1024px it sets `open`, so a screen reader hears the column as expanded and
   an engine that predates ::details-content (Safari before 18.4, Chrome before
   131), where the CSS pin has no effect, shows the links too. Setting `open`
   on a column the CSS already shows changes nothing visible, so there is no
   flash to guard against, and nothing here animates, so there is nothing to
   guard for reduced motion either.

   On a phone the init pass does nothing: it never closes a column, because a
   visitor may already have opened one before this deferred script ran. Only a
   change of the media query, a tablet rotated from landscape to portrait,
   takes `open` back off so the accordion starts folded again. The editor's
   section reload re-runs the pass because the rebuilt columns arrive closed. */
(function () {
  'use strict';

  var desktop = window.matchMedia('(min-width: 1024px)');

  function apply(force) {
    if (!desktop.matches && !force) return;
    var columns = document.querySelectorAll('.footer__column--menu');
    for (var i = 0; i < columns.length; i++) {
      if (desktop.matches) columns[i].setAttribute('open', '');
      else columns[i].removeAttribute('open');
    }
  }

  apply(false);
  desktop.addEventListener('change', function () { apply(true); });
  document.addEventListener('shopify:section:load', function () { apply(false); });
})();
